import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import IconButton from '@mui/material/IconButton';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import {
  deleteComment,
  deleteSubcomment,
  getCommentsForum,
  reportComment,
  reportSubComment
} from 'store/lesson-actions';

import classes from './CommentOptions.module.css';

const CommentOptions = props => {
  const { t } = useTranslation(['forum']);
  const dispatch = useDispatch();
  const userInfo = useSelector(state => state.userInfo);
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const openMenuHandler = event => {
    setAnchorEl(event.currentTarget);
  };

  const CloseMenuHandler = () => {
    setAnchorEl(null);
  };

  const reportPostHandler = () => {
    (async () => {
      if (props.subcomment) {
        await reportSubComment(props.idComment, true);
      } else {
        await reportComment(props.idComment, true);
      }
    })();
    setAnchorEl(null);
  };

  const deleteCommentHandler = () => {
    (async () => {
      let comments = [];
      if (props.subcomment) {
        comments.push({ idSubComment: props.idComment });
        let deleteSubcommentStatus = await deleteSubcomment(
          comments,
          false
        );
        if (deleteSubcommentStatus) {
          props.showAnswers();
        }
      } else {
        comments.push({ idComment: props.idComment });
        let deleteCommentStatus = await deleteComment(
          comments,
          false
        );
        if (deleteCommentStatus) {
          dispatch(
            getCommentsForum(props.idLesson, 'es', 50, 1, true)
          );
        }
      }
    })();
    setAnchorEl(null);
  };

  const editPostHandler = () => {
    props.editCommentHandler();
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        className={
          props.subcomment
            ? classes.moreOptionsSubcommentIcon
            : classes.moreOptionsIcon
        }
        onClick={openMenuHandler}
      >
        <MoreHorizIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={CloseMenuHandler}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        {props.adminComment ? (
          <MenuItem onClick={editPostHandler}>{t('edit')}</MenuItem>
        ) : (
          <MenuItem onClick={reportPostHandler}>
            {t('report')}
          </MenuItem>
        )}
        {userInfo.data.academyAdmin && (
          <MenuItem onClick={deleteCommentHandler}>
            {t('eliminate')}
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

CommentOptions.propTypes = {
  // eslint-disable-next-line react/require-default-props
  adminComment: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  subcomment: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  idComment: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  showAnswers: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  editCommentHandler: PropTypes.func
};

export default CommentOptions;
